// -----------------------------------------------------------------------
// <copyright file="DiagnosticCapabilityType.ts" company="Microsoft">
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

export enum DiagnosticCapabilityType {
  dafv1,
  dafv1WithParams,
  dafv2,
  dafv2WithParams,
}
